import {
  readQueryParamNumber,
  readQueryParamString,
} from "/Helpers/readQueryParam";
import BaseSearchClient, { BaseListResult } from "/Helpers/BaseSearchClient";
import { EventListFilters } from "./EventListPage";

export interface EventListResults extends BaseListResult {}
export default class EventListClient extends BaseSearchClient {
  public GetItems = ({
    ...props
  }: EventListFilters): Promise<EventListResults> => {
    const { pageNumber, upcomingEvents } = props;
    return fetch(
      `${this.endpoint}?pageNumber=${pageNumber}&upcoming=${upcomingEvents}&language=${this.language}&eventListPageId=${this.pageId}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error from event list API");
        }
        return response.json();
      })
      .catch((error) => {
        //gracefull return
        return { error: true, message: error.message };
      });
  };

  public BuildUrlFromProps = ({
    ...props
  }: EventListFilters): string | undefined => {
    const { pageNumber, upcomingEvents } = props;
    if (this._baseUrl)
      return `${this._baseUrl}?page=${pageNumber}&tab=${upcomingEvents ? "upcoming" : "past"}`;
  };

  private GetPageNumberFromUrl = (): number =>
    readQueryParamNumber("page") ?? 1;

  private GetUpcomingEventFlag = (): boolean =>
    readQueryParamString("tab") === "upcoming";

  public GetParams = () => {
    return {
      pageNumber: this.GetPageNumberFromUrl(),
      upcomingEvents: this.GetUpcomingEventFlag(),
    };
  };
}
